module.exports = __webpack_public_path__ + "static/media/img_sendero.58eafe05.jpg";